import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/utils";
import { PublicNavbar } from "../ui/public-navbar";
import Footer from "../../footer/footer";
import bg from "../../assets/img/spacia/web/Background.png";

export function AuthLayout({ children, className, showNavbar = true, showFooter = true, showLogo = true, ...props }) {
  return (
    <div className="relative flex flex-col w-full min-h-screen">
      {/* Background Image */}
      <div className="fixed inset-0 z-0 bg-center bg-no-repeat bg-cover" style={{ backgroundImage: `url(${bg})` }} />

      {/* Overlay for better text readability */}
      <div className="fixed inset-0 z-0 bg-black/5" />

      {/* Navbar (conditional) */}
      {showNavbar && (
        <div className="relative z-10">
          <PublicNavbar />
        </div>
      )}

      {/* Logo - Top Left (only show if navbar is hidden and showLogo is true) */}
      {!showNavbar && showLogo && (
        <div className="absolute top-6 left-6 md:top-8 md:left-8 z-10">
          <Link to="/home" className="block transition-transform hover:scale-105">
            <img src="/assets/img/logo/logo.png" alt="Spacia Logo" className="w-auto h-20 md:h-24" />
          </Link>
        </div>
      )}

      {/* Main Content */}
      <main className={cn("relative z-10 flex-1 flex items-center justify-center w-full", className)} {...props}>
        {children}
      </main>

      {/* Footer (conditional) */}
      {showFooter && (
        <div className="relative z-10">
          <Footer />
        </div>
      )}
    </div>
  );
}
